<template>
    <div class="imageListSelector imageList" :data-maxlength="maxLength">
        <div class="imageItem" :style="'width: ' + imageSize + 'px; height: ' + imageSize + 'px'"
             v-for="imageItem in value" :key="imageItem">
            <img :src="imageItem" class="fullSpace cover"/>
            <span class="removeButton" @click="removeImageItem(imageItem)">&times;</span>
        </div>
        <label class="imageItem" :style="'width: ' + imageSize + 'px; height: ' + imageSize + 'px'"
               v-show="maxLength ? value.length < maxLength : true">
            <input class="hidden" type="file"
               name="file" @change="onChangeImageFile"/>
            <i class="icon greyPlusIcon"/>
        </label>
    </div>
</template>

<script>
import arrayHelper  from "@util/arrayHelper";
import appHelper    from "@util/appHelper";
import fileApi      from "@api/file";

export default {
    name: "imageListSelector",
    props : {
        value : {
            type : Array,
            default : () => {
                return [];
            }
        },
        imageSize : {
            type : Number,
            default : 84
        },
        cellPadding : {
            type : Number,
            default : 0
        },
        maxLength : {
            type : Number,
            default: 0
        }
    },
    methods : {
        removeImageItem(imageItem) {
            this.value = arrayHelper.removeElement(this.value, imageItem);
            this.$emit('input', this.value);
        },

        onChangeImageFile(event) {
            let e = event.currentTarget;
            let file = e.files ? e.files[0] : null;
            if (!file)
            {
                return;
            }

            fileApi.uploadImage(file).then((res) => {
                let result = res.data;
                if (typeof(result) === 'string')
                {
                    result = JSON.parse(result);
                }
                this.value.push(result.data);

                this.$emit('input', this.value);

            }).catch(appHelper.generalAjaxError);
        },

    }
}
</script>

<style lang="scss" scoped>
.imageList {
    .imageItem {
        position: relative;
        float: left;
        background: #F7F7F7;
        border: 1px solid #DFDFE0;
        border-radius: 8px;
        margin: 0 10px 10px 0;
        overflow: hidden;
        .removeButton {
            position: absolute;
            z-index: 1;
            right: 4px;
            top: 4px;

            width: 12px;
            height: 12px;
            line-height: 12px;
            background: rgba(128, 128, 128, 0.7);
            border-radius: 50%;
            text-align: center;
            color: white;
        }

        .greyPlusIcon {
            position: absolute;
            z-index: 1;
            left: 50%;
            top: 50%;
            margin-left: -17px;
            margin-top: -17px;
            width: 34px;
            height: 34px;
        }
    }

}
</style>
